import { SlackOAuthPage } from '@features/auth/components/SlackOAuthPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/slackoauth')({ component: SlackOAuthPage });
